import { BaseService } from "./BaseService";
import { FunctionGroup, MeasuresType } from "../types/app.enums";
import { Measures } from "../types/app.interfaces";

export class UAMeasuresService extends BaseService {
  burgissUniverseCalcIRRPercentile(
    peergroupID: any[][],
    percentile: any,
    currency: any,
    startDate?: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      uniqueCellId,
      peergroupID,
      percentile,
      currency,
      startDate,
      endDate,
      returnConstituentCount,
      filter,
      MeasuresType.IRRPercentile
    );
    return super._pushOperation(
      "BurgissUniverseCalcIRRPercentile",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.UAMeasures
    );
  }
  burgissUniverseCalcNetCashFlowPercentile(
    peergroupID: any[][],
    percentile: any,
    currency: any,
    startDate?: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    index?: any,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      uniqueCellId,
      peergroupID,
      percentile,
      currency,
      startDate,
      endDate,
      returnConstituentCount,
      filter,
      MeasuresType.NetCashFlowPercentile,
      index
    );
    return super._pushOperation(
      "burgissUniverseCalcNetCashFlowPercentile",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.UAMeasures
    );
  }

  burgissUniverseCalcIRR_QTDPercentile(
    peergroupID: any[][],
    percentile: any,
    currency: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      uniqueCellId,
      peergroupID,
      percentile,
      currency,
      null,
      endDate,
      returnConstituentCount,
      filter,
      MeasuresType.IRR_QTDPercentile
    );
    return super._pushOperation(
      "BurgissUniverseCalcIRR_QTDPercentile",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.UAMeasures
    );
  }

  burgissUniverseCalcIRR_YTDPercentile(
    peergroupID: any[][],
    percentile: any,
    currency: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      uniqueCellId,
      peergroupID,
      percentile,
      currency,
      null,
      endDate,
      returnConstituentCount,
      filter,
      MeasuresType.IRR_YTDPercentile
    );
    return super._pushOperation(
      "BurgissUniverseCalcIRR_YTDPercentile",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.UAMeasures
    );
  }

  burgissUniverseCalcIRR_1YearPercentile(
    peergroupID: any[][],
    percentile: any,
    currency: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      uniqueCellId,
      peergroupID,
      percentile,
      currency,
      null,
      endDate,
      returnConstituentCount,
      filter,
      MeasuresType.IRR_1YearPercentile
    );
    return super._pushOperation(
      "BurgissUniverseCalcIRR_1YearPercentile",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.UAMeasures
    );
  }

  burgissUniverseCalcIRR_3YearPercentile(
    peergroupID: any[][],
    percentile: any,
    currency: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      uniqueCellId,
      peergroupID,
      percentile,
      currency,
      null,
      endDate,
      returnConstituentCount,
      filter,
      MeasuresType.IRR_3YearPercentile
    );
    return super._pushOperation(
      "BurgissUniverseCalcIRR_3YearPercentile",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.UAMeasures
    );
  }

  burgissUniverseCalcIRR_5YearPercentile(
    peergroupID: any[][],
    percentile: any,
    currency: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      uniqueCellId,
      peergroupID,
      percentile,
      currency,
      null,
      endDate,
      returnConstituentCount,
      filter,
      MeasuresType.IRR_5YearPercentile
    );
    return super._pushOperation(
      "BurgissUniverseCalcIRR_5YearPercentile",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.UAMeasures
    );
  }

  burgissUniverseCalcIRR_10YearPercentile(
    peergroupID: any[][],
    percentile: any,
    currency: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      uniqueCellId,
      peergroupID,
      percentile,
      currency,
      null,
      endDate,
      returnConstituentCount,
      filter,
      MeasuresType.IRR_10YearPercentile
    );
    return super._pushOperation(
      "BurgissUniverseCalcIRR_10YearPercentile",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.UAMeasures
    );
  }

  burgissUniverseCalcIRR_15YearPercentile(
    peergroupID: any[][],
    percentile: any,
    currency: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      uniqueCellId,
      peergroupID,
      percentile,
      currency,
      null,
      endDate,
      returnConstituentCount,
      filter,
      MeasuresType.IRR_15YearPercentile
    );
    return super._pushOperation(
      "BurgissUniverseCalcIRR_15YearPercentile",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.UAMeasures
    );
  }

  burgissUniverseCalcIRR_20YearPercentile(
    peergroupID: any[][],
    percentile: any,
    currency: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      uniqueCellId,
      peergroupID,
      percentile,
      currency,
      null,
      endDate,
      returnConstituentCount,
      filter,
      MeasuresType.IRR_20YearPercentile
    );
    return super._pushOperation(
      "BurgissUniverseCalcIRR_20YearPercentile",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.UAMeasures
    );
  }

  burgissUniverseCalcDPIPercentile(
    peergroupID: any[][],
    percentile: any,
    currency: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      uniqueCellId,
      peergroupID,
      percentile,
      currency,
      null,
      endDate,
      returnConstituentCount,
      filter,
      MeasuresType.DPIPercentile
    );
    return super._pushOperation(
      "BurgissUniverseCalcDPIPercentile",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.UAMeasures
    );
  }
  burgissUniverseCalcGSS_DirectAlphaPercentile(
    peerGroupId?: any[][],
    percenTile?: any,
    uaCurrency?: string,
    beginDate?: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    index?: string,
    uniqueCellId?: string
  ) {
    // /const IsBurgissManagedC: any = validations.GetIsBurgissManagedClient(index);
    const objRequest = this.createPayload(
      uniqueCellId,
      peerGroupId,
      percenTile,
      uaCurrency,
      beginDate,
      endDate,
      returnConstituentCount,
      filter,
      MeasuresType.GSS_DirectAlpha_Percentile,
      index
    );
    return super._pushOperation(
      "BurgissUniverseCalcGGS_DirectAlphaPercentile",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.UAMeasures
    );
  }
  burgissUniverseCalcKS_PMEPercentile(
    peerGroupId?: any[][],
    percenTile?: any,
    uaCurrency?: string,
    beginDate?: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    index?: string,
    uniqueCellId?: string
  ) {
    //const IsBurgissManagedC: any = validations.GetIsBurgissManagedClient(index);
    const objRequest = this.createPayload(
      uniqueCellId,
      peerGroupId,
      percenTile,
      uaCurrency,
      beginDate,
      endDate,
      returnConstituentCount,
      filter,
      MeasuresType.KS_PME_Percentile,
      index
    );
    return super._pushOperation(
      "BurgissUniverseCalcKS_PMEPercentile",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.UAMeasures
    );
  }
  burgissUniverseCalcLN_ICMIRRPercentile(
    peerGroupId?: any[][],
    percenTile?: any,
    uaCurrency?: string,
    beginDate?: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    index?: string,
    uniqueCellId?: string
  ) {
    //const IsBurgissManagedC: any = validations.GetIsBurgissManagedClient(index);
    const objRequest = this.createPayload(
      uniqueCellId,
      peerGroupId,
      percenTile,
      uaCurrency,
      beginDate,
      endDate,
      returnConstituentCount,
      filter,
      MeasuresType.LN_ICMIRR_Percentile,
      index
    );
    return super._pushOperation(
      "BurgissUniverseCalcLN_ICMIRRPercentile",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.UAMeasures
    );
  }
  burgissUniverseCalcLN_ICMIRRSpreadPercentile(
    peerGroupId?: any[][],
    percenTile?: any,
    uaCurrency?: string,
    beginDate?: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    index?: string,
    uniqueCellId?: string
  ) {
    //const IsBurgissManagedC: any = validations.GetIsBurgissManagedClient(index);
    const objRequest = this.createPayload(
      uniqueCellId,
      peerGroupId,
      percenTile,
      uaCurrency,
      beginDate,
      endDate,
      returnConstituentCount,
      filter,
      MeasuresType.LN_ICMIRRSpread_Percentile,
      index
    );
    return super._pushOperation(
      "BurgissUniverseCalcLN_ICMIRRSpreadPercentile",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.UAMeasures
    );
  }
  burgissUniverseCalcLN_ICMValuationSpreadPercentile(
    peerGroupId?: any[][],
    percenTile?: any,
    uaCurrency?: string,
    beginDate?: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    index?: string,
    uniqueCellId?: string
  ) {
    //const IsBurgissManagedC: any = validations.GetIsBurgissManagedClient(index);
    const objRequest = this.createPayload(
      uniqueCellId,
      peerGroupId,
      percenTile,
      uaCurrency,
      beginDate,
      endDate,
      returnConstituentCount,
      filter,
      MeasuresType.LN_ICMValuationSpread_Percentile,
      index
    );
    return super._pushOperation(
      "BurgissUniverseCalcLN_ICMValuationSpreadPercentile",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.UAMeasures
    );
  }

  burgissUniverseCalcTWRR_QTDPooled(
    peerGroupId?: any[][],
    currency?: string,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    index?: string,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      uniqueCellId,
      peerGroupId,
      null,
      currency,
      null,
      endDate,
      returnConstituentCount,
      filter,
      MeasuresType.TWRR_QTDPooled,
      index
    );
    return super._pushOperation(
      "BurgissUniverseCalcTWRR_QTDPooled",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.UAMeasures
    );
  }
  burgissUniverseCalcIRR_NWPooled(
    peerGroupId?: any[][],
    currency?: string,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    index?: string,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      uniqueCellId,
      peerGroupId,
      null,
      currency,
      null,
      endDate,
      returnConstituentCount,
      filter,
      MeasuresType.IRR_NWPooled,
      index
    );
    return super._pushOperation(
      "burgissUniverseCalcIRR_NWPooled",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.UAMeasures
    );
  }
  burgissUniverseCalcIRRPooled(
    peerGroupId?: any[][],
    currency?: string,
    startDate?: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    index?: string,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      uniqueCellId,
      peerGroupId,
      null,
      currency,
      startDate,
      endDate,
      returnConstituentCount,
      filter,
      MeasuresType.IRRPooled,
      index
    );
    return super._pushOperation(
      "burgissUniverseCalcIRRPooled",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.UAMeasures
    );
  }
  burgissUniverseCalcIRR_QTDPooled(
    peerGroupId?: any[][],
    currency?: string,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    index?: string,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      uniqueCellId,
      peerGroupId,
      null,
      currency,
      null,
      endDate,
      returnConstituentCount,
      filter,
      MeasuresType.IRR_QTDPooled,
      index
    );
    return super._pushOperation(
      "burgissUniverseCalcIRR_QTDPooled",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.UAMeasures
    );
  }
  burgissUniverseCalcIRR_YTDPooled(
    peerGroupId?: any[][],
    currency?: string,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    index?: string,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      uniqueCellId,
      peerGroupId,
      null,
      currency,
      null,
      endDate,
      returnConstituentCount,
      filter,
      MeasuresType.IRR_YTDPooled,
      index
    );
    return super._pushOperation(
      "burgissUniverseCalcIRR_YTDPooled",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.UAMeasures
    );
  }
  burgissUniverseCalcIRR_1YearPooled(
    peerGroupId?: any[][],
    currency?: string,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    index?: string,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      uniqueCellId,
      peerGroupId,
      null,
      currency,
      null,
      endDate,
      returnConstituentCount,
      filter,
      MeasuresType.IRR_1YearPooled,
      index
    );
    return super._pushOperation(
      "burgissUniverseCalcIRR_1YearPooled",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.UAMeasures
    );
  }
  burgissUniverseCalcIRR_3YearPooled(
    peerGroupId?: any[][],
    currency?: string,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    index?: string,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      uniqueCellId,
      peerGroupId,
      null,
      currency,
      null,
      endDate,
      returnConstituentCount,
      filter,
      MeasuresType.IRR_3YearPooled,
      index
    );
    return super._pushOperation(
      "burgissUniverseCalcIRR_3YearPooled",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.UAMeasures
    );
  }
  burgissUniverseCalcIRR_5YearPooled(
    peerGroupId?: any[][],
    currency?: string,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    index?: string,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      uniqueCellId,
      peerGroupId,
      null,
      currency,
      null,
      endDate,
      returnConstituentCount,
      filter,
      MeasuresType.IRR_5YearPooled,
      index
    );
    return super._pushOperation(
      "burgissUniverseCalcIRR_5YearPooled",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.UAMeasures
    );
  }
  burgissUniverseCalcIRR_10YearPooled(
    peerGroupId?: any[][],
    currency?: string,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    index?: string,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      uniqueCellId,
      peerGroupId,
      null,
      currency,
      null,
      endDate,
      returnConstituentCount,
      filter,
      MeasuresType.IRR_10YearPooled,
      index
    );
    return super._pushOperation(
      "burgissUniverseCalcIRR_10YearPooled",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.UAMeasures
    );
  }
  burgissUniverseCalcIRR_15YearPooled(
    peerGroupId?: any[][],
    currency?: string,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    index?: string,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      uniqueCellId,
      peerGroupId,
      null,
      currency,
      null,
      endDate,
      returnConstituentCount,
      filter,
      MeasuresType.IRR_15YearPooled,
      index
    );
    return super._pushOperation(
      "burgissUniverseCalcIRR_15YearPooled",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.UAMeasures
    );
  }
  burgissUniverseCalcIRR_20YearPooled(
    peerGroupId?: any[][],
    currency?: string,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    index?: string,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      uniqueCellId,
      peerGroupId,
      null,
      currency,
      null,
      endDate,
      returnConstituentCount,
      filter,
      MeasuresType.IRR_20YearPooled,
      index
    );
    return super._pushOperation(
      "burgissUniverseCalcIRR_20YearPooled",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.UAMeasures
    );
  }
  burgissUniverseCalcDPIPooled(
    peerGroupId?: any[][],
    currency?: string,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    index?: string,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      uniqueCellId,
      peerGroupId,
      null,
      currency,
      null,
      endDate,
      returnConstituentCount,
      filter,
      MeasuresType.DPIPooled,
      index
    );
    return super._pushOperation(
      "burgissUniverseCalcDPIPooled",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.UAMeasures
    );
  }
  burgissUniverseCalcRVPIPooled(
    peerGroupId?: any[][],
    currency?: string,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    index?: string,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      uniqueCellId,
      peerGroupId,
      null,
      currency,
      null,
      endDate,
      returnConstituentCount,
      filter,
      MeasuresType.RVPIPooled,
      index
    );
    return super._pushOperation(
      "burgissUniverseCalcRVPIPooled",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.UAMeasures
    );
  }
  burgissUniverseCalcTVPIPooled(
    peerGroupId?: any[][],
    currency?: string,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    index?: string,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      uniqueCellId,
      peerGroupId,
      null,
      currency,
      null,
      endDate,
      returnConstituentCount,
      filter,
      MeasuresType.TVPIPooled,
      index
    );
    return super._pushOperation(
      "burgissUniverseCalcTVPIPooled",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.UAMeasures
    );
  }
  burgissUniverseCalcValuationPooled(
    peerGroupId?: any[][],
    currency?: string,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    index?: string,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      uniqueCellId,
      peerGroupId,
      null,
      currency,
      null,
      endDate,
      returnConstituentCount,
      filter,
      MeasuresType.ValuationPooled,
      index
    );
    return super._pushOperation(
      "burgissUniverseCalcValuationPooled",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.UAMeasures
    );
  }

  burgissUniverseCalcMIRRPooled(
    peerGroupId?: any[][],
    uaCurrency?: string,
    beginDate?: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    index?: string,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      uniqueCellId,
      peerGroupId,
      null,
      uaCurrency,
      beginDate,
      endDate,
      returnConstituentCount,
      filter,
      MeasuresType.MIRRPooled,
      index
    );
    return super._pushOperation(
      "BurgissUniverseCalcMIRRPooled",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.UAMeasures
    );
  }
  burgissUniverseCalcRIRRPooled(
    peerGroupId?: any[][],
    uaCurrency?: string,
    beginDate?: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      uniqueCellId,
      peerGroupId,
      null,
      uaCurrency,
      beginDate,
      endDate,
      returnConstituentCount,
      filter,
      MeasuresType.RIRRPooled
    );
    return super._pushOperation(
      "BurgissUniverseCalcRIRRPooled",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.UAMeasures
    );
  }
  burgissUniverseCalcDistributionsPooled(
    peerGroupId?: any[][],
    uaCurrency?: string,
    beginDate?: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      uniqueCellId,
      peerGroupId,
      null,
      uaCurrency,
      beginDate,
      endDate,
      returnConstituentCount,
      filter,
      MeasuresType.DistributionsPooled
    );
    return super._pushOperation(
      "BurgissUniverseCalcDistributionsPooled",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.UAMeasures
    );
  }
  burgissUniverseCalcNetCashFlowPooled(
    peerGroupId?: any[][],
    uaCurrency?: string,
    beginDate?: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      uniqueCellId,
      peerGroupId,
      null,
      uaCurrency,
      beginDate,
      endDate,
      returnConstituentCount,
      filter,
      MeasuresType.NetCashFlowPooled
    );
    return super._pushOperation(
      "BurgissUniverseCalcNetCashFlowPooled",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.UAMeasures
    );
  }
  burgissUniverseCalcPaidInCapitalPooled(
    peerGroupId?: any[][],
    uaCurrency?: string,
    beginDate?: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      uniqueCellId,
      peerGroupId,
      null,
      uaCurrency,
      beginDate,
      endDate,
      returnConstituentCount,
      filter,
      MeasuresType.PaidInCapitalPooled
    );
    return super._pushOperation(
      "BurgissUniverseCalcPaidInCapitalPooled",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.UAMeasures
    );
  }
  burgissUniverseCalcGSS_DirectAlphaPooled(
    peerGroupId?: any[][],
    uaCurrency?: string,
    beginDate?: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    index?: string,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      uniqueCellId,
      peerGroupId,
      null,
      uaCurrency,
      beginDate,
      endDate,
      returnConstituentCount,
      filter,
      MeasuresType.GSS_DirectAlphaPooled,
      index
    );
    return super._pushOperation(
      "BurgissUniverseCalcGGS_DirectAlphaPooled",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.UAMeasures
    );
  }
  burgissUniverseCalcKS_PMEPooled(
    peerGroupId?: any[][],
    uaCurrency?: string,
    beginDate?: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    index?: string,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      uniqueCellId,
      peerGroupId,
      null,
      uaCurrency,
      beginDate,
      endDate,
      returnConstituentCount,
      filter,
      MeasuresType.KS_PMEPooled,
      index
    );
    return super._pushOperation(
      "BurgissUniverseCalcKS_PMEPooled",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.UAMeasures
    );
  }
  burgissUniverseCalcLN_ICMIRRPooled(
    peerGroupId?: any[][],
    uaCurrency?: string,
    beginDate?: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    index?: string,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      uniqueCellId,
      peerGroupId,
      null,
      uaCurrency,
      beginDate,
      endDate,
      returnConstituentCount,
      filter,
      MeasuresType.LN_ICMIRRPooled,
      index
    );
    return super._pushOperation(
      "BurgissUniverseCalcLN_ICMIRRPooled",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.UAMeasures
    );
  }
  burgissUniverseCalcLN_ICMIRRSpreadPooled(
    peerGroupId?: any[][],
    uaCurrency?: string,
    beginDate?: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    index?: string,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      uniqueCellId,
      peerGroupId,
      null,
      uaCurrency,
      beginDate,
      endDate,
      returnConstituentCount,
      filter,
      MeasuresType.LN_ICMIRRSpreadPooled,
      index
    );
    return super._pushOperation(
      "BurgissUniverseCalcLN_ICMIRRSpreadPooled",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.UAMeasures
    );
  }
  burgissUniverseCalcLN_ICMValuationSpreadPooled(
    peerGroupId?: any[][],
    uaCurrency?: string,
    beginDate?: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    index?: string,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      uniqueCellId,
      peerGroupId,
      null,
      uaCurrency,
      beginDate,
      endDate,
      returnConstituentCount,
      filter,
      MeasuresType.LN_ICMValuationSpreadPooled,
      index
    );
    return super._pushOperation(
      "BurgissUniverseCalcLN_ICMValuationSpreadPooled",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.UAMeasures
    );
  }
  burgissUniverseCalcCapitalizationPooled(
    peerGroupId?: any[][],
    uaCurrency?: string,
    beginDate?: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      uniqueCellId,
      peerGroupId,
      null,
      uaCurrency,
      beginDate,
      endDate,
      returnConstituentCount,
      filter,
      MeasuresType.CapitalizationPooled
    );
    return super._pushOperation(
      "BurgissUniverseCalcCapitalizationPooled",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.UAMeasures
    );
  }
  burgissUniverseCalcDistributionsPercentile(
    peerGroupId?: any[][],
    percenTile?: any,
    currency?: string,
    beginDate?: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      uniqueCellId,
      peerGroupId,
      percenTile,
      currency,
      beginDate,
      endDate,
      returnConstituentCount,
      filter,
      MeasuresType.DISTRIBUTIONS_PERCENTILE,
      null
    );
    return super._pushOperation(
      "BurgissUniverseCalcDistributionsPercentile",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.UAMeasures
    );
  }
  burgissUniverseCalcMIRRPercentile(
    peerGroupId?: any[][],
    percenTile?: any,
    currency?: string,
    beginDate?: any,
    endDate?: any,
    index?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      uniqueCellId,
      peerGroupId,
      percenTile,
      currency,
      beginDate,
      endDate,
      returnConstituentCount,
      filter,
      MeasuresType.MIRR_PERCENTILE,
      index
    );
    return super._pushOperation(
      "BurgissUniverseCalcMIRRPercentile",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.UAMeasures
    );
  }
  burgissUniverseCalcPaidInCapitalPercentile(
    peerGroupId?: any[][],
    percenTile?: any,
    currency?: string,
    beginDate?: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      uniqueCellId,
      peerGroupId,
      percenTile,
      currency,
      beginDate,
      endDate,
      returnConstituentCount,
      filter,
      MeasuresType.PAIDINCAPITAL_PERCENTILE,
      null
    );
    return super._pushOperation(
      "BurgissUniverseCalcPaidInCapitalPercentile",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.UAMeasures
    );
  }
  burgissUniverseCalcRIRRPercentile(
    peerGroupId?: any[][],
    percenTile?: any,
    currency?: string,
    beginDate?: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      uniqueCellId,
      peerGroupId,
      percenTile,
      currency,
      beginDate,
      endDate,
      returnConstituentCount,
      filter,
      MeasuresType.RIRR_PERCENTILE,
      null
    );
    return super._pushOperation(
      "BurgissUniverseCalcRIRRPercentile",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.UAMeasures
    );
  }
  burgissUniverseCalcRVPIPercentile(
    peerGroupId?: any[][],
    percenTile?: any,
    currency?: string,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      uniqueCellId,
      peerGroupId,
      percenTile,
      currency,
      null,
      endDate,
      returnConstituentCount,
      filter,
      MeasuresType.RVPI_PERCENTILE,
      null
    );
    return super._pushOperation(
      "BurgissUniverseCalcRVPIPercentile",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.UAMeasures
    );
  }
  burgissUniverseCalcTVPIPercentile(
    peerGroupId?: any[][],
    percenTile?: any,
    currency?: string,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      uniqueCellId,
      peerGroupId,
      percenTile,
      currency,
      null,
      endDate,
      returnConstituentCount,
      filter,
      MeasuresType.TVPI_PERCENTILE,
      null
    );
    return super._pushOperation(
      "BurgissUniverseCalcTVPIPercentile",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.UAMeasures
    );
  }
  burgissUniverseCalcValuationPercentile(
    peerGroupId?: any[][],
    percenTile?: any,
    currency?: string,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      uniqueCellId,
      peerGroupId,
      percenTile,
      currency,
      null,
      endDate,
      returnConstituentCount,
      filter,
      MeasuresType.VALUATION_PERCENTILE,
      null
    );
    return super._pushOperation(
      "BurgissUniverseCalcValuationPercentile",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.UAMeasures
    );
  }

  createPayload(
    alias: string = null,
    peerGroupId: any[][] = null,
    percenTile: any = null,
    uaCurrency: string = null,
    beginDate: any = null,
    endDate: any = null,
    returnConstituentCount: any = null,
    filter: any = "",
    measure: string = null,
    index: any = null
  ) {
    filter = "ExcelDna.Integration.ExcelMissing";
    const measuresObject: Measures = {
      excludeBalanceSheetItems: false,
      excludeUndisclosedItems: false,
      excludeUnknownEntities: false,
      excludeRealizationsPriorToClosingDate: null,
      financeIndexID: null,
      financePremium: null,
      reinvestmentIndexID: null,
      reinvestmentPremium: null,
      forceRollForward: null,
      peergroupID: String(peerGroupId).toUpperCase() == "ALL" ? "-1" : String(peerGroupId),
      percentile: percenTile,
      currency: uaCurrency,
      returnConstituentCount: returnConstituentCount,
      investmentID: null,
      portfolioID: null,
      isHoldingCalc: false,
      returnPooledResult: true,
      baseCurrency: true,
      alternateBaseCurrency: null,
      attributeName: null,
      adjustToMostRecent: false,
      measure: measure,
      beginDate: beginDate,
      endDate: endDate,
      year: null,
      indexID: index,
      premium: null,
      idType: null,
      selectionsetID: null,
      assetID: null,
      weightingMethod: null,
      value: null,
      filter: filter,
      rankValue: null,
      bMUHistoricalWindowLengthQtrs: 0,
      maxAgeDiffYears: null,
      horizon: null,
      maxDroppedPeriods: null,
      lastHistoricalEOQDate: null,
      numSimulations: null,
      desiredSampleSize: null,
      minSampleSize: null,
      sampleStatistic: null,
      stopOn: null,
      requireReportedValuation: 0,
      alias: alias,
      currencyHedgesetId: null,
      foFLookThrough: false,
      useReceivedDate: false,
      excludeFrozenAsset: true,
      useAlternateFundSize: false,
      dynamicParameter: null,
      universe: null,
      weight: null,
      commitment: null,
    };
    return measuresObject;
  }
}
